import HBIcon from "@/components/HBIcon";
import HBSwiper from "@/components/HBSwiper";
import {
  RecommendWord,
  Topic,
  TopicResource,
  TopicStructure,
} from "@/services/zhuanti";
import { Breadcrumb } from "antd";
import Head from "next/head";
import Link from "next/link";
import { When } from "react-if";
import styles from "./index.module.less";

interface Props {
  level: 1 | 2 | 3;
  topic: TopicStructure;
  recommend: RecommendWord[];
  resource?: TopicResource;
}

export function SEOHead(props: { topic: Topic }) {
  const { topic } = props;
  const { keyword } = topic;

  return (
    <>
      <Head>
        <title>
          {keyword}图片-{keyword}设计素材-{keyword}模板下载_花瓣网
        </title>
        <meta
          name="keywords"
          content={`${keyword}图片, ${keyword}设计, ${keyword}素材, ${keyword}图片下载, ${keyword}模板下载`}
        />
        <meta
          name="description"
          content={`花瓣网为您提供${keyword}图片，更多${keyword}相关设计素材、设计灵感和模板尽在花瓣网。免费一键收藏和下载。`}
        />
      </Head>
      <div className="golbalHiddenH1">
        <h1>{keyword}</h1>
      </div>
    </>
  );
}

export function Header(props: Props) {
  const { topic, recommend } = props;

  const headerRecommend = recommend.slice(0, 30);
  return (
    <div className={styles.header}>
      <div className={styles.title}>{topic.keyword}</div>
      <div className={styles.desc}>{topic.description}</div>
      <When condition={headerRecommend.length}>
        {/* @ts-ignore */}
        <HBSwiper
          className={styles.swiper}
          iconClassName={styles.headerSwiperIcon}
        >
          {headerRecommend.map((item, idx) => {
            return (
              <TopicButton
                key={idx}
                href={`/zhuanti/${item.alias}`}
                word={item.word}
              />
            );
          })}
        </HBSwiper>
      </When>
    </div>
  );
}

export function MoreTopicFooter(props: Props) {
  const { recommend, topic } = props;

  const headerRecommend = recommend.slice(30);
  if (!headerRecommend.length) return null;
  return (
    <div className={styles.footer}>
      <div className={styles.title}>{`更多${topic.keyword}`}</div>
      <div className={styles.footItemWrap}>
        {/* @ts-ignore */}
        {headerRecommend.map((item, idx) => {
          return (
            <TopicButton
              key={idx}
              href={`/zhuanti/${item.alias}`}
              word={item.word}
            />
          );
        })}
      </div>
    </div>
  );
}

export function TopicButton(props: { href: string; word: string }) {
  return (
    <Link
      className={styles.headerItem}
      href={props.href}
      legacyBehavior={false}
    >
      {props.word}
    </Link>
  );
}

const separator = <HBIcon type="ic_chevron_right" />;

export function BreadNav(props: Props) {
  const { topic, level } = props;
  if (level === 1) {
    return (
      <Breadcrumb separator={separator}>
        <Breadcrumb.Item>
          <Link href={`/`}>首页</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link href={`/zhuanti`}>精选专题</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{topic.keyword}</Breadcrumb.Item>
      </Breadcrumb>
    );
  }
  const l3 = level === 3 ? topic : null;
  const l2 = level === 2 ? topic : topic.parent;
  const l1 = l2?.parent;

  return (
    <Breadcrumb separator={separator}>
      <Breadcrumb.Item>
        <Link href={`/`}>首页</Link>
      </Breadcrumb.Item>
      <When condition={!!l1}>
        <Breadcrumb.Item>
          <Link href={`/zhuanti/${l1.alias}`}>{l1.keyword}</Link>
        </Breadcrumb.Item>
      </When>
      <When condition={!!l2}>
        <Breadcrumb.Item>
          <Link href={`/zhuanti/${l2.alias}`}>{l2.keyword}</Link>
        </Breadcrumb.Item>
      </When>
      <When condition={!!l3}>
        <Breadcrumb.Item>{topic.keyword}</Breadcrumb.Item>
      </When>
    </Breadcrumb>
  );
}
